export const isPdfPrintVersion = () =>
  typeof window !== "undefined" &&
  window.location.pathname.includes("/pdfprintversion");
